interface LockIconSize36Props {
  className?: string;
}

const defaultProps = {
  className: undefined,
};

function LockIconSize36({ className }: LockIconSize36Props) {
  return (
    <svg
      className={className}
      fill="none"
      height="36"
      viewBox="0 0 36 36"
      width="36"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.1429 16.2051H10.8571C9.28571 16.2051 8 17.4974 8 19.0769V29.1282C8 30.7076 9.28571 32 10.8571 32H25.1429C26.7143 32 28 30.7076 28 29.1282V19.0769C28 17.4974 26.7143 16.2051 25.1429 16.2051Z"
        fill="#FFB600"
      />
      <path
        clipRule="evenodd"
        d="M17.1483 4.09397C21.768 3.35207 25.7857 6.7368 25.7857 11.323C25.7857 12.3143 24.9862 13.1179 24 13.1179C23.0138 13.1179 22.2143 12.3143 22.2143 11.323C22.2143 9.01749 20.2331 7.23327 17.7107 7.63892L17.7071 7.6395V7.6395C16.0658 7.89997 14.7857 9.53892 14.7857 11.6102V18.3589C14.7857 19.3502 13.9862 20.1538 13 20.1538C12.0138 20.1538 11.2143 19.3502 11.2143 18.3589V11.6102C11.2143 8.22556 13.3621 4.69586 17.1483 4.09397Z"
        fill="#FFB600"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M18 21.9487C18.789 21.9487 19.4286 22.5916 19.4286 23.3846V24.8205C19.4286 25.6136 18.789 26.2564 18 26.2564C17.211 26.2564 16.5714 25.6136 16.5714 24.8205V23.3846C16.5714 22.5916 17.211 21.9487 18 21.9487Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

LockIconSize36.defaultProps = defaultProps;

export default LockIconSize36;
